import { CampaignsView } from '@/components/campaigns/CampaignsView';

export default function CampaignsPage() {
  return <CampaignsView />;
}
